export const BASE_URL = "https://admin.gadgetcare.co.id/upload/";
// export const BASE_URL = "http://localhost/gadget/gadgetcare/upload/";
